import { render, staticRenderFns } from "./MoleculeFeedProductsSearch.vue?vue&type=template&id=62650107&"
import script from "./MoleculeFeedProductsSearch.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedProductsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports